export default __webpack_public_path__ + "static/media/pic5.346b1614.jpg";